'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ResourceKind() {
}
export { $c_Lapp_data_ResourceKind as $c_Lapp_data_ResourceKind };
$p = $c_Lapp_data_ResourceKind.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ResourceKind;
/** @constructor */
function $h_Lapp_data_ResourceKind() {
}
export { $h_Lapp_data_ResourceKind as $h_Lapp_data_ResourceKind };
$h_Lapp_data_ResourceKind.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lapp_data_ResourceKind = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.data.ResourceKind", ({
  jV: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_ResourceKind as $d_Lapp_data_ResourceKind };
//# sourceMappingURL=app.data.-Resource-Kind.js.map
